<p-inputGroup>
    <input
        pInputText
        type="text"
        inputmode="email"
        autocomplete="email"
        [attr.data-testid]="getDataTestId()"
        [formControl]="formControl"
        [placeholder]="props.placeholder"
    />
    <p-button [icon]="props.icon" [disabled]="!formControl?.value" (onClick)="btnClick($event)" />
</p-inputGroup>
